"use client";
import { Button } from "@/components/ui/button";
import { Globe } from "lucide-react";
import { usePathname, useRouter } from "next/navigation";

export default function LanguageToggle({ className = "", isScrolled = false }) {
  const pathname = usePathname() || "/";
  const router = useRouter();

  const getCurrentLang = () => {
    if (pathname.startsWith("/ar")) return "ar";
    if (pathname.startsWith("/en")) return "en";
    return "en"; // default
  };

  const currentLang = getCurrentLang();
  const targetLang = currentLang === "en" ? "ar" : "en";

  const toggleLanguage = () => {
    // Remove current language from path
    let newPath = pathname;
    if (pathname.startsWith("/ar") || pathname.startsWith("/en")) {
      newPath = pathname.substring(3) || "/";
    }

    // Add new language to path
    const finalPath = `/${targetLang}${newPath}`;
    router.push(finalPath);
  };

  const label = targetLang === "ar" ? "AR" : "EN";

  return (
    <Button
      onClick={toggleLanguage}
      variant="outline"
      size="sm"
      className={`cursor-pointer bg-transparent transition-all duration-300 ${
        isScrolled
          ? "text-[#0a367b] border-[#0a367b]/30 hover:text-[#dfa428] hover:bg-[#dfa428]/10 hover:border-[#dfa428]/50"
          : "text-white border-white/30 hover:text-[#dfa428] hover:bg-[#dfa428]/10 hover:border-[#dfa428]/50"
      } ${className}`}
    >
      <Globe className="w-3 h-3 mr-1" />
      {label}
    </Button>
  );
}
